import { FooterKey } from '../SearchIcons'

/** The palette's keyboard hints. */
export function GlobalSearchFooter() {
  return (
    <div className="border-default flex shrink-0 flex-wrap items-center justify-center gap-x-3 gap-y-1 border-t px-3 py-2 text-[10px] text-muted">
      <span className="inline-flex items-center gap-1">
        <FooterKey label="Up" />
        <FooterKey label="Down" />
        <span>navigate results</span>
      </span>
      <span className="inline-flex items-center gap-1">
        <FooterKey label="Left" />
        <FooterKey label="Right" />
        <span>navigate tabs</span>
      </span>
      <span className="inline-flex items-center gap-1">
        <FooterKey label="Enter" />
        <span>select result</span>
      </span>
      <span className="inline-flex items-center gap-1">
        <FooterKey label="Esc" />
        <span>close</span>
      </span>
    </div>
  )
}
